import { APP_FEATURES, appFeature } from 'modules/organizer/domain/interfaces/available-feature';
import { TournamentPlan } from 'modules/organizer/domain/interfaces/tournament-plan';

/** Значение из адреса — фича, только если это известное имя; всё прочее игнорируется. */
export function parseAppFeature(raw: string | null): appFeature | null {
  return APP_FEATURES.find((feature) => feature === raw) ?? null;
}

/** Самый дешёвый тариф, в который входит фича; `null`, если ни один её не содержит. */
export function pickCheapestPlanWithFeature(plans: TournamentPlan[], feature: appFeature): TournamentPlan | null {
  return plans.reduce<TournamentPlan | null>((cheapest, plan) => {
    if (!plan.features.some((item) => item.feature === feature)) {
      return cheapest;
    }

    return !cheapest || plan.priceInMinorUnits < cheapest.priceInMinorUnits ? plan : cheapest;
  }, null);
}
